import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase/config";

import Login from "./components/Auth/Login";
import Dashboard from "./components/Dashboard/Dashboard";
// import InternalChat from "./components/IdentityChat/InternalChat";
import PublicChat from "./components/IdentityChat/PublicChat";
import CreateChat from "./components/IdentityChat/CreateChat";

import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route
          path="/"
          element={user ? <Navigate to="/dashboard" /> : <Login />}
        />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={user ? <Dashboard user={user} /> : <Navigate to="/" />}
        />

        {/* <Route
          path="/chat/:conversationId"
          element={user ? <PublicChat user={user} /> : <Navigate to="/" />}
        /> */}

        <Route
          path="/chat/:conversationId"
          element={<PublicChat user={user} />}
        />

        <Route
          path="/create-chat"
          element={user ? <CreateChat user={user} /> : <Navigate to="/" />}
        />

        {/* Catch All */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;